export class Toast {
    id: string = "";
    message: string = "";
    level: string = "";
}
